<template>
    <div>
        <ndt-welds-table 
            ref="table" 
            :tableName="'weld_request_ndt_welds'"
            :archived="1"
            :columnData="columnData"
        >
        </ndt-welds-table>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import NdtWeldsTable from '@/components/pages/project/welding/ndt_welds/ndt_welds_table.vue';

export default {
    name: 'ndt_welds_overview_archived_requests',
    components: {
        NdtWeldsTable,
    },
    data() {
        return {
            columnData: [
                {
                    label: Vue.i18n.translate('table.request_no'),
                    field: 'weld_request_overview.ndt_request_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'weld.drawing.line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'weld.drawing.iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'weld.drawing.page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spool_no'),
                    field: 'weld.spool.spool_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_class'),
                    field: 'weld.drawing.line.line_class',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_material'),
                    field: 'weld.weld_material.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_no'),
                    field: 'weld.weld_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_type'),
                    field: 'weld.project_setting.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_place'),
                    field: 'weld.weld_place',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_date'),
                    field: 'weld.welder_date_1',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder1'),
                    field: 'weld.welder1.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder2'),
                    field: 'weld.welder2.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.filler_material'),
                    field: 'weld.filler_material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'weld.drawing.line.ped_category',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_size'),
                    field: 'weld.weld_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_dimension'),
                    field: 'weld.weld_dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'weld.drawing_progress_status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.inspection'),
                    field: 'weld.inspection.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_type'),
                    field: 'testing_typeV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.required_testing_date'),
                    field: 'required_testing_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location'),
                    field: 'location',
                    width: '170px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.company'),
                    field: 'company.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.remark_no_1'),
                    field: 'remark_no_1',
                    width: '200px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.real_testing_date'),
                    field: 'real_testing_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.certificate_no_1'),
                    field: 'certificate_no_1',
                    width: '170px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.certificate_no_2'),
                    field: 'certificate_no_2',
                    width: '170px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.repair'),
                    field: 'repair',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.repair_reason'),
                    field: 'repair_reason.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.remark_no_2'),
                    field: 'remark_no_2',
                    width: '200px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.checked_client'),
                    field: 'checked_client',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.client_name'),
                    field: 'client_name',
                    width: '220px',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.view_files'),
                    field: '',
                    numeric: false,
                    html: false,
                    showAddFilesButton: true,
                },
                {
                    label: Vue.i18n.translate('table.closed'),
                    field: 'closed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.deleted'),
                    field: 'deleted',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true,
                },
            ],
        }
    },
    methods: {
        onLoadTable () {
            this.$refs.table.onLoadTable();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/welding/ndt_welds/ndt_welds_overview_archived_requests.vue